import moment from 'moment';

let randomNumber = 0;

// 8位循环数字（从0开始，不够8位前补0）
export function getRandomDigts() {
  randomNumber += 1;
  if (randomNumber > 99999999) {
    randomNumber = 0;
  }
  const digts = (Array(8).join(0) + randomNumber).slice(-8); // 不足8位前面补0
  return digts;
}

// 请求时间, YYYYMMDDHHMMSS
export function getRequestTime() {
  const requestTime = moment().format('YYYYMMDDHHmmss');
  return requestTime;
}

// 2位渠道编号 +YYYYMMDDHHMMSS+8位循环数字（从0开始，不够8位前补0）
export function getRequestId() {
  const requestId = `08${getRequestTime()}${getRandomDigts()}`;
  return requestId;
}
